const EMPTY_MESSAGE = 'Turnerings Historiken är tom';

function updateHideEmptyTournamentHistory() {
  const withCard = document.querySelectorAll('[data-page-profile-history]:has(.results-card)');
  withCard.forEach((block) => {
    block.style.removeProperty('display');
    const placeholder = block.nextElementSibling;
    if (placeholder?.hasAttribute('data-page-profile-history-empty')) {
      placeholder.remove();
    }
  });

  const withoutCard = document.querySelectorAll('[data-page-profile-history]:not(:has(.results-card))');
  withoutCard.forEach((block) => {
    block.style.display = 'none';
    const placeholder = block.nextElementSibling;
    if (!placeholder?.hasAttribute('data-page-profile-history-empty')) {
      const emptyBlock = document.createElement('div');
      emptyBlock.setAttribute('data-page-profile-history-empty', '');
      emptyBlock.className = 'tournament-history-empty';

      const titleDiv = document.createElement('div');
      titleDiv.className = 'tournament-history-empty__title';
      titleDiv.textContent = 'Turneringshistorik';

      const messageDiv = document.createElement('div');
      messageDiv.className = 'tournament-history-empty__content';
      messageDiv.textContent = EMPTY_MESSAGE;

      emptyBlock.appendChild(titleDiv);
      emptyBlock.appendChild(messageDiv);
      block.after(emptyBlock);
    }
  });
}

function initHideEmptyTournamentHistory() {
  updateHideEmptyTournamentHistory();

  const blocks = document.querySelectorAll('[data-page-profile-history]');
  if (!blocks.length) return;

  const runCheck = () => requestAnimationFrame(updateHideEmptyTournamentHistory);

  const observer = new MutationObserver((mutations) => {
    const hasRelevantChange = mutations.some(
      (m) => m.type === 'childList' && (m.addedNodes.length || m.removedNodes.length)
    );
    if (hasRelevantChange) runCheck();
  });

  blocks.forEach((block) => {
    observer.observe(block, {
      childList: true,
      subtree: true,
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initHideEmptyTournamentHistory);
} else {
  initHideEmptyTournamentHistory();
}